import { AutogenModelExcisetaxChargeRec, AutogenRowExcisetaxChargeRec } from "./autogen/AutogenModelExcisetaxChargeRec";

export class ModelExcisetaxChargeRec extends AutogenModelExcisetaxChargeRec<RowExcisetaxChargeRec> {
	constructor() {
		super(RowExcisetaxChargeRec);
	}
}

export class RowExcisetaxChargeRec extends AutogenRowExcisetaxChargeRec {
}